// © Microsoft Corporation. All rights reserved.

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";

export const PopoverStyles = (config: DesignSystem) => ({
    popoverContainer: {
        display: "inline",
        position: "relative",

        "& .cwt-popover-overlay": {
            position: "absolute",
            "z-index": "-1",
            background: "transparent",
            width: "calc(100% + 8px)",
            height: "calc(100% + 8px)",
            top: "-4px",
            [applyLocalizedProperty("left", "right", config.direction)]: "-4px"
        },

        "& .cwt-popover-content": {
            position: "absolute",
            "z-index": "99999999999",
            opacity: "0",
            "&[data-show]": {
                opacity: "1"
            }
        }
    }
});